/**
 * glyph Semantic UI map
 * @param className
 * @return {html: string}
 */
let glyphSemanticUIIcon = (className) => {
    return {html: '<i class="' + className + ' icon"></i>'};
};

/**
 * icon Html element
 * @param className
 * @return {html: string}
 */
let iconHtml = (className) => {
    return {html: '<span class="' + className + '"></span>'};
};


/**
 * Helper Quali pour FancyTree
 * @type object
 */
const qualiTreeHelper = {
    /**
     * Convertir un flat array en tree
     * @param childList
     * @param disableGroupCheckbox
     * @param expandAll
     * @return {*}
     */
    flatToFancyTree(childList, disableGroupCheckbox = false, expandAll = false) {
        var parent, nodeMap = {};

        if (childList.kind === "tasks#tasks") {
            childList = childList.items;
        }

        // Pass 1: store all tasks in reference map
        $.each(childList, function (i, c) {

            if (c.type_noeud == '0') {
                c.folder = true;
                // Simuler les regroupements de noeuds comme des dossiers

                if (c.nParent == '0') {
                    // ROOT
                    c.expanded = true;
                }

                if (disableGroupCheckbox) {
                    c.checkbox = false;
                    // Désactive la selection sur un regroupement quand le plugin checkbox est activé
                }

            }

            if (expandAll) {
                c.expanded = true;
            }

            nodeMap[c.id] = c;
        });

        // Pass 2: adjust fields and fix child structure
        childList = $.map(childList, function (c) {
            // Rename 'key' to 'id'
            c.key = c.id;
            delete c.id;
            // Set checkbox for completed tasks
            c.selected = c.selected ?? (c.status === "completed");


            // Check if c is a child node
            if (c.parent) {
                // add c to `children` array of parent node

                parent = nodeMap[c.parent];

                if (!parent) {
                    delete (c.parent);
                    return c;
                }

                if (parent.children) {
                    parent.children.push(c);
                } else {
                    parent.children = [c];
                }
                return null;  // Remove c from childList
            }
            return c;  // Keep top-level nodes
        });

        // Pass 3: sort children by 'position'
        $.each(childList, function (i, c) {
            if (c.children && c.children.length > 1) {
                c.children.sort(function (a, b) {
                    return ((a.position < b.position) ? -1 : ((a.position > b.position) ? 1 : 0));
                });
            }
        });

        return childList;
    },
    /**
     * Glyph icon
     * @param mapOverride
     */
    glyph: (mapOverride = {}) => {
        let map = {
            checkbox: iconHtml("far fa-square"),
            checkboxSelected: iconHtml("far fa-check-square"),
            checkboxUnknown: iconHtml("far fa-minus-square"),
            radio: iconHtml("far fa-circle"),
            radioSelected: iconHtml("fa fa-circle"),
            radioUnknown: iconHtml("fa fa-circle"),
            dragHelper: iconHtml("fas fa-arrow-right"),
            dropMarker: iconHtml("fas fa-arrow-circle-right"),
            error: iconHtml("fas fa-exclamation-triangle"),
            expanderClosed: iconHtml("fas fa-caret-right"),
            expanderLazy: iconHtml("fas fa-caret-right"),
            expanderOpen: iconHtml("fas fa-caret-down"),
            loading: iconHtml("fas fa-spinner"),
            nodata: iconHtml("fas fa-exclamation-triangle"),
            noExpander: iconHtml(""),
            doc: iconHtml("far fa-building"),
            docOpen: iconHtml("far fa-building"),
            folder: iconHtml("fas fa-city"),
            folderOpen: iconHtml("fas fa-city")
        };

        Object.entries(mapOverride).forEach(overrideItem => {
            const [key, overrideValue] = overrideItem;

            if (map.hasOwnProperty(key)) {
                map[key] = iconHtml(overrideValue);
            }
        });

        return {
            preset: "bootstrap3",
            map: map
        };
    },
    /**
     * Glyph icon
     * @param mapOverride
     */
    glyphSemanticUI: (mapOverride = {}) => {
        let map = {
            checkbox: glyphSemanticUIIcon("square outline"),
            checkboxSelected: glyphSemanticUIIcon("check square"),
            checkboxUnknown: glyphSemanticUIIcon("minus square"),
            radio: glyphSemanticUIIcon("circle outline"),
            radioSelected: glyphSemanticUIIcon("circle"),
            radioUnknown: glyphSemanticUIIcon("circle outline"),
            dragHelper: glyphSemanticUIIcon("arrow right"),
            dropMarker: glyphSemanticUIIcon("arrow alternate circle right"),
            error: glyphSemanticUIIcon("exclamation triangle"),
            expanderClosed: glyphSemanticUIIcon("caret right"),
            expanderLazy: glyphSemanticUIIcon("caret right"),
            expanderOpen: glyphSemanticUIIcon("caret down"),
            loading: glyphSemanticUIIcon("spinner loading"),
            nodata: glyphSemanticUIIcon("exclamation circle"),
            noExpander: glyphSemanticUIIcon(""),
            doc: glyphSemanticUIIcon("building outline"),
            docOpen: glyphSemanticUIIcon("building outline"),
            folder: glyphSemanticUIIcon("building"),
            folderOpen: glyphSemanticUIIcon("building")
        };

        Object.entries(mapOverride).forEach(overrideItem => {
            const [key, overrideValue] = overrideItem;

            if (map.hasOwnProperty(key)) {
                map[key] = overrideValue;
            }
        });

        return {
            preset: "bootstrap3",
            map: map
        };
    }
};